var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"commonshare-loader"},[_c('div',{staticClass:"text-center"},[_c('LazyPictureComponent',{attrs:{"image":_vm.loader,"class-name":['commonshare-logo',_vm.white?'white':undefined]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }